import styled from 'styled-components'

const Image = styled.img<{
  width: number
  height: number
  mw?: string
  minW?: string
  clipped?: boolean
  bordered?: boolean
}>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  object-fit: cover;
  border-radius: 8px;
  ${({ mw }) => mw && `max-width: ${mw};`}
  ${({ minW }) => minW && `min-width: ${minW};`}
  

  --button-border-color: rgba(255, 255, 255, 0.20);
  ${({ bordered }) =>
    bordered && `border: 1px solid var(--button-border-color);`}
`

export default Image
